import { Dimensions } from 'react-native';
import { moduleName } from '../moduleInfo';
import type { RootState } from '../reducers';
import { Toast } from '@shopuptech/expo-shopup-ui';
import type { Loadable } from 'recoil';

type ActionType = {
  type: string;
  [key: string]: any;
};

export const action = (actionArgs: ActionType) => ({
  ...actionArgs,
  meta: { moduleName },
});

export const getRootState = (state: any): RootState => state[moduleName];

export type IsEmptyValueType =
  | string
  | number
  | undefined
  | null
  | boolean
  | any;

export const isEmpty = (value: IsEmptyValueType): boolean =>
  value === undefined || value === null || value === '';

export const isMobile = () => {
  return Dimensions.get('window').width <= 768;
};

export const handleToastType = (success: boolean) => {
  return success ? 'SUCCESS' : 'ERROR';
};

export const showToast = (message: string, success: boolean) => {
  Toast(message, handleToastType(success));
};

export const getLoadableData = <T>(loadable: Loadable<T>, initResponse: T) => {
  return {
    response: loadable.state === 'hasValue' ? loadable.contents : initResponse,
    isLoading: loadable.state === 'loading',
  };
};

export const getErrorMessage = (error: any) => {
  if (error.res && error.res.body && error.res.body.error) {
    return error.res.body.error.message;
  }
  if (error.message) {
    return error.message;
  }
  return 'Something went wrong';
};

export const getApprovalActionResponse = (
  actionName: string,
  response: string,
) => {
  if (!response) return '';
  return actionName === 'Approve'
    ? 'Approval request approved successfully!'
    : 'Approval request rejected successfully!';
};
